module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/153-cuba-630cd5484c24b573499dfb3c2ad25f62.svg";